import * as React from "react";

function SvgInventoryFilled(props) {
  return <svg viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M35.277 7.285L19 .055 2.725 7.287A4.168 4.168 0 00.25 11.096V37.75h37.5V11.096c0-1.646-.97-3.142-2.473-3.81zm-5.86 26.298h-8.334V25.25h8.334v8.333zm-6.25-12.5h-8.334V12.75h8.334v8.333zm-6.25 4.167v8.333H8.583V25.25h8.334z" /></svg>;
}

export default SvgInventoryFilled;